var isTreeDropNodeValid = function isTreeDropNodeValid(_ref) {
  var canDrop = _ref.canDrop,
    sourceNodeContext = _ref.sourceNodeContext,
    target = _ref.target;
  return sourceNodeContext.id !== target.context.id && sourceNodeContext.parentId !== target.context.id && !target.context.ancestorIds.includes(sourceNodeContext.id) && canDrop(target);
};
var canDraggedNodeBeDroppedOnTopBar = function canDraggedNodeBeDroppedOnTopBar(draggedNodeContext, currentNodeContext, canDrop) {
  return draggedNodeContext.id !== currentNodeContext.id && draggedNodeContext.getNextSiblingId() !== currentNodeContext.id && !currentNodeContext.ancestorIds.includes(draggedNodeContext.id) && canDrop(currentNodeContext.parentId ? {
    context: currentNodeContext.getParentContext(),
    node: currentNodeContext.getParentNode()
  } : void 0);
};
var canDraggedNodeBeDroppedOnBottomBar = function canDraggedNodeBeDroppedOnBottomBar(draggedNodeContext, currentNodeContext, canDrop) {
  return draggedNodeContext.id !== currentNodeContext.id && draggedNodeContext.getPrevSiblingId() !== currentNodeContext.id && !currentNodeContext.ancestorIds.includes(draggedNodeContext.id) && canDrop(currentNodeContext.parentId ? {
    context: currentNodeContext.getParentContext(),
    node: currentNodeContext.getParentNode()
  } : void 0);
};

export { canDraggedNodeBeDroppedOnBottomBar, canDraggedNodeBeDroppedOnTopBar, isTreeDropNodeValid };
